import React from 'react';
import { Spinner } from 'reactstrap';
import styles from './Screenshots.module.scss';
import { ReportFiltersBar } from '@/components/ReportFiltersBar';
import { ScreenshotsLightbox } from './ScreenshotsLightbox.component';
import { SessionCardComponent as SessionCard } from './components/SessionCard.component';
import { EmptyState } from '@/components/EmptyState';

// Pure presentational — no Redux/react-query/service calls. Rendered by both
// Screenshots.component.jsx (real) and Screenshots.demo.component.jsx
// (static fixture-backed); a future redesign only ever needs to touch this
// file plus whichever container's props it changes.
export const ScreenshotsView = ({
  membersOptions,
  selectedMember,
  onMemberFilterChange,
  membersLoading,
  membersError,
  membersErrorObj,
  refetchMembers,
  timezoneOptions,
  selectedTimezone,
  onTimezoneChange,
  timezonesLoading,
  date,
  onDateChange,
  onRefresh,
  loading,
  flattenedSessions,
  sessionScreenshots,
  loadingScreenshots,
  expandedSessions,
  onSessionOpenChange,
  onOpenScreenshotModal,
  screenshotModalOpen,
  closeScreenshotModal,
  allScreenshotsList,
  selectedScreenshotIndex,
  setSelectedScreenshotIndex,
  employeeName,
  teamName,
  modalOpenToken,
}) => {
  return (
    <div className={styles.screenshotsPage}>
      <ReportFiltersBar
        membersOptions={membersOptions}
        selectedMember={selectedMember}
        onMemberFilterChange={onMemberFilterChange}
        membersLoading={membersLoading}
        membersError={membersError}
        membersErrorObj={membersErrorObj}
        refetchMembers={refetchMembers}
        timezoneOptions={timezoneOptions}
        selectedTimezone={selectedTimezone}
        onTimezoneChange={onTimezoneChange}
        timezonesLoading={timezonesLoading}
        date={date}
        onDateChange={onDateChange}
        onRefresh={onRefresh}
        showExport={false}
      />

      {loading && (
        <div className={styles.loaderContainer}>
          <Spinner color="primary" />
          <p className="mt-3 text-muted">Loading sessions...</p>
        </div>
      )}

      {!loading && !flattenedSessions.length && (
        <EmptyState
          illustration
          title="No Sessions Found"
          description="No sessions found for the selected filters. Try a different date range or employee."
        />
      )}

      {!loading && flattenedSessions.length > 0 && (
        <div className={styles.sessionsListContainer}>
          {flattenedSessions.map(({ dayLabel, dayKey, session }, index) => (
            <SessionCard
              key={session.id}
              dayLabel={dayLabel}
              dayKey={dayKey}
              session={session}
              selectedTimezone={selectedTimezone}
              screenshots={sessionScreenshots[session.id] || []}
              isLoadingScreenshots={
                session.isSplit && session.parentSessionId
                  ? loadingScreenshots[session.parentSessionId] ||
                    loadingScreenshots[session.id]
                  : loadingScreenshots[session.id]
              }
              isOpenOnStart={index === 0}
              isExpanded={expandedSessions.has(session.id)}
              colorIndex={index}
              onOpenChange={(open) => onSessionOpenChange(session.id, open)}
              onOpenScreenshotModal={(clickedIndex) =>
                onOpenScreenshotModal(
                  clickedIndex,
                  sessionScreenshots[session.id] || []
                )
              }
            />
          ))}
        </div>
      )}

      <ScreenshotsLightbox
        open={screenshotModalOpen}
        onClose={closeScreenshotModal}
        allScreenshotsList={allScreenshotsList}
        selectedScreenshotIndex={selectedScreenshotIndex}
        setSelectedScreenshotIndex={setSelectedScreenshotIndex}
        selectedTimezone={selectedTimezone}
        employeeName={employeeName}
        teamName={teamName}
        lightboxKey={modalOpenToken}
      />
    </div>
  );
};
